import React from "react";
import ReactGA from 'react-ga';

export default class Contact extends React.Component {

    sendMessage(e) {
        e.preventDefault();
        const formData = new FormData(document.querySelector('form'));
        const values = [...formData?.values()];
        ReactGA.event({ category: 'COntact', event: 'form-submit', label: 'Submitting Contact Form' }, values);
    }
    render() {
        return (
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Contact</h2>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-12 info">
                                <i className="bx bx-map"></i>
                                <h3>Address</h3>
                                <p> New Ranip,
                                    <br />
                                    Ahmedabad - 382470
                                </p>
                            </div>
                            {/* <div clas */}
                            <div className="col-lg-12 info">
                                <i className="bx bx-envelope"></i>
                                <h3>Email Us</h3>
                                <p> coderman401.ai@gmail.com
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <form className="php-email-form" data-aos="fade-up" onSubmit={this.sendMessage}>
                            <div className="form-group">
                                <input placeholder="Your Name" type="text" name="name" className="form-control"
                                    id="name" required />
                            </div>
                            <div className="form-group mt-3">
                                <input placeholder="Your Email" type="email" className="form-control" name="email"
                                    id="email" required />
                            </div>
                            <div className="form-group mt-3">
                                <input placeholder="Subject" type="text" className="form-control" name="subject"
                                    id="subject" required />
                            </div>
                            <div className="form-group mt-3">
                                <textarea placeholder="Message" className="form-control" name="message" rows="5"
                                    required></textarea>
                            </div>
                            <div className="my-3">
                                <div className="loading">Loading</div>
                                <div className="error-message"></div>
                                <div className="sent-message">
                                    Your message has been sent. Thank
                                    you!
                                </div>
                            </div>
                            <div className="text-center">
                                <button type="submit">
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
